import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { BoolFilter } from "gen/search/service/service_pb"
import { UUID } from "shared-ts/classes/uuid"
import { WebUrl } from "shared-web/lib/webUrl"

export const StaffTabs = {
  PERMISSIONS: "permissions",
  GENERAL: "general",
  NOTIFICATION_PREFERENCES: "notification-preferences",
} as const
export type StaffTab = (typeof StaffTabs)[keyof typeof StaffTabs]

export function adminStaffs(): WebUrl {
  return {
    pathname: "/admin/staff",
    query: { status: BoolFilter.TRUE.toString() },
  }
}

export function adminStaff(id?: PBUUID, tab?: StaffTab): WebUrl {
  return {
    pathname: `/admin/staff/${UUID.idString(id)}/${tab ?? StaffTabs.PERMISSIONS}`,
  }
}
